/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-param-reassign */
import {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, ToggleField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './InstructorInfo.metadata.json5';
import { useTranslator } from '@jutro/locale';
import messages from './InstructorInfo.messages';

function InstructorInfo(props) {

    const {
        data: instructorInfoVM,
        updateWizardData,
        submissionVM,
        instructorInfoPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const translator = useTranslator()

    const addInstInfo = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            instructorInfoVM.value = instructorInfoVM.value || []

            const { _xCenter, _dtoName } = instructorInfoVM;

            const InstInfoObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            InstInfoObjVM.yeaproSerFie.value = 0
            InstInfoObjVM.fie3 = instructorInfoVM?.value?.length + 1;

            instructorInfoVM.pushElement(
                InstInfoObjVM
            );
            updateWizardData(submissionVM);
        },
        [instructorInfoVM, viewModelService, updateWizardData, submissionVM]
    );

    const handleValueChange = useCallback(
        () => {

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            instructorInfoVM.value.splice(index, 1);

            instructorInfoVM.value.map((instructor) => {
                if (instructor.fie3 > index) {
                    instructor.fie3 = instructor.fie3 - 1;
                }
            })

            _.set(submissionVM.value, instructorInfoPath, instructorInfoVM.value);
            updateWizardData(submissionVM);
        }, [instructorInfoVM.value, submissionVM, instructorInfoPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'fie3') {
                const value = !_.isUndefined(item.fie3) ? item.fie3 : index + 1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'namPerInsClaFie') {
                const value = item.namPerInsClaFie ? item.namPerInsClaFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namPerInsClaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'certoteaFie') {
                const value = item.certoteaFie !== undefined ? item.certoteaFie : 'true';

                return (
                    <ToggleField
                        availableValues={[
                            {
                                code: 'true',
                                name: translator(messages.certificationYes)
                            },
                            {
                                code: 'false',
                                name: translator(messages.certificationNo)
                            }
                        ]}
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        onValueChange={(val, changedPath) => {
                            item.certoteaFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaproSerFie') {
                const value = !_.isUndefined(item.yeaproSerFie) ? item.yeaproSerFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaproSerFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange])

    const removeInstructorInfoTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`InstructorInfoTable`]: {
            data: instructorInfoVM?.value?.sort((a,b) => a.fie3 - b.fie3)
        }

    }), [instructorInfoVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addInstInfo,
            getTableCell,
            removeInstructorInfoTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            instructorInfoVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [instructorInfoVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={instructorInfoVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

InstructorInfo.propTypes = wizardProps;
export default withRouter(InstructorInfo);
